<section class="review-section-wrapper" [ngClass]="bgColorTheme ? bgColorTheme : 'blue-light-bg'">
  <div class="box-container">
    <div class="box">
      <div class="box__left">
        <h2 class="box__heading color-gray" [innerHTML]="customTextList.title | translate"></h2>

        <div class="box__detail">{{ customTextList.detail | translate }} </div>

        <div class="btn-wrapper">
          <a
            class="btn-try-free"
            href="/reviews"
            rel="noopener noreferrer"
            target="_blank"
            aria-label="Review FlowAccount"
            >{{ customTextList.button | translate }}
          </a>
        </div>
      </div>

      <div class="box__right">
        <div class="content-section">
          <div class="header-title">
            <div class="title">
              <swiper-container class="swiper" appSwiper [config]="config" init="false">
                <ng-container *ngFor="let item of filteredReviewList$ | async">
                  <swiper-slide class="swiper-slide" (click)="linkVideo(item.data.cardYoutubeLink.iv)">
                    <div class="service-banner">
                      <div class="banner next">
                        <div class="box">
                          <div class="link-color" rel="noopener">
                            <div class="partner-testimonial-card">
                              <picture class="picture-cover">
                                <source srcset="{{ item.data.cardImage.iv }}" type="image/webp" />
                                <img
                                  src="{{ item.data.cardImage.iv }}"
                                  width="100%"
                                  loading="lazy"
                                  alt="{{ item.data.cardTitle.iv }}"
                                  class="image-cover"
                                />
                                <div class="play-video">
                                  <picture>
                                    <source
                                      srcset="
                                        https://flowaccountcdn.com/new_landing/image/mobile/Tutorial/Play_button.png
                                      "
                                      type="image/webp"
                                    />
                                    <img
                                      src="https://flowaccountcdn.com/new_landing/image/mobile/Tutorial/Play_button.png"
                                      class="icon-play"
                                      alt="{{ item.data.cardTitle.iv }}"
                                      loading="lazy"
                                    />
                                  </picture>
                                </div>
                              </picture>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </swiper-slide>
                </ng-container>

                <div class="swiper-button-prev">
                  <i class="cursor fas fa-arrow-left"></i>
                </div>
                <div class="swiper-button-next">
                  <i class="cursor fas fa-arrow-right"></i>
                </div>
                <div style="width: 80px !important" class="swiper-pagination"></div>
              </swiper-container>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</section>
